// Sökfält för /endcustomeraccountview/search.
// Nycklarna måste matcha AccountSearchFieldEnum i backend exakt.

// Håll i synk med EndCustomerAccountViewRepository.MinSearchLength.
export const MIN_SEARCH_LENGTH = 3;

export const SEARCH_FIELDS = [
  { key: "InvoiceNumber", label: "Fakturanummer", selectedByDefault: true },
  { key: "OCR", label: "OCR" },
  { key: "CustomerNumber", label: "Kundnr" },
  { key: "CustomerName", label: "Kundnamn" },
  { key: "CustomerOrgNo", label: "Org.nr" },
  { key: "CustomerAddress", label: "Adress" },
];

export const DEFAULT_SEARCH_FIELD_KEYS = SEARCH_FIELDS.filter(
  (f) => f.selectedByDefault
).map((f) => f.key);
